import { z } from 'zod';
import { ChannelSchema, IdSchema, IsoDateTimeSchema } from './common';

/** Юрлицо / сеть ресторанов. */
export const TenantSchema = z.object({
  id: IdSchema,
  name: z.string().min(1),
  slug: z.string().regex(/^[a-z0-9-]+$/),
  createdAt: IsoDateTimeSchema,
});
export type Tenant = z.infer<typeof TenantSchema>;

/** Точка / заведение внутри тенанта. */
export const VenueSchema = z.object({
  id: IdSchema,
  tenantId: IdSchema,
  name: z.string().min(1),
  city: z.string().min(1),
  address: z.string().nullish(),
  timezone: z.string().default('Europe/Moscow'),
  channels: z.array(ChannelSchema).min(1),
});
export type Venue = z.infer<typeof VenueSchema>;

export const VenueSummarySchema = VenueSchema.pick({
  id: true,
  tenantId: true,
  name: true,
  city: true,
  timezone: true,
});
export type VenueSummary = z.infer<typeof VenueSummarySchema>;
